import { LiveProvider, LiveEditor, LiveError, LivePreview } from "react-live";

const CodeExecuter = ({ code, scope }: any) => {
  return (
    <LiveProvider code={code} scope={scope} noInline={true}>
      {/* <div className="mb-4 overflow-y-scroll h-[900px]">
        <div>
          <LiveEditor />
        </div>
      </div> */}
      <div className="mb-4 text-red-500">
        <LiveError />
      </div>
      <div className="">
        <LivePreview />
      </div>
    </LiveProvider>
  );
};

export default CodeExecuter;
